class AppContext {
    constructor() {
        this.attachMember = this.attachMember.bind(this);

        function IDGeneratorUtility() {
            this._length = 10;
             // eslint-disable-next-line
            this._timestamp = +new Date;
            this._getRandomInt = function(min, max) {
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
            this.generate = function() {
                var parts = this._timestamp.toString().split("").reverse();
                var id = "";
                for(var i = 0; i < this._length; ++i) {
                var index = this._getRandomInt(0, parts.length - 1);
                id += parts[index];	 
                }
                return id;
            }
        }
        var objIDGeneratorUtility = new IDGeneratorUtility();
        this.attachMember("getUniqueID",function() {
            return objIDGeneratorUtility.generate();
        });
    }

    attachMember(name, member) {
        this[name] = member;
    }
}
export default new AppContext();